"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHMenuSpecV3 = void 0;
const KHEventHandler_1 = require("../../KHEventHandler");
const KHHelperFunctions_1 = require("../../KHHelperFunctions");
const KHMenuEntryV3_1 = require("./KHMenuEntryV3");
class KHMenuSpecV3 extends KHEventHandler_1.KHEventHandler {
    constructor(config) {
        super();
        this.options = [];
        this.selectedIndex = -1;
        this.config = config;
        this.options.push(...(config.menuEntries || []));
        this.options.forEach(element => {
            element.registerCallback('description_updated', (data) => {
                this.sendUpdateDescriptionEvent(data.text);
            });
        });
        this.setSelected(this.getDefaultSelection());
    }
    getDescription() {
        let current = this.options[this.selectedIndex];
        if (current) {
            return current.getDescription();
        }
        return "";
    }
    setForbidInput(forbid) {
        if (this.inputForbidden === forbid)
            return;
        this.inputForbidden = forbid;
        if (this.inputForbidden) {
            this.setSelected(undefined);
        }
        else {
            this.setSelected(this.getDefaultSelection());
        }
    }
    getDefaultSelection() {
        if (this.config.defaultSelection) {
            return this.config.defaultSelection;
        }
        const defaults = this.options.filter(x => x.config.isDefaultSelection);
        if (defaults.length > 0)
            return defaults[0];
        return this.options[0];
    }
    setSelected(menuOption, userInitiated = true) {
        let newIndex = this.options.indexOf(menuOption);
        this.setSelectedIndex(newIndex);
    }
    getSelectedOption() {
        return this.options[this.selectedIndex];
    }
    downPressed() {
        if (this.inputForbidden)
            return;
        const selected = this.getSelectedOption();
        if (selected && selected.config.downCallback) {
            selected.config.downCallback();
        }
        else {
            this.config.menuNavigator.onDown(this);
        }
    }
    upPressed() {
        if (this.inputForbidden)
            return;
        const selected = this.getSelectedOption();
        if (selected && selected.config.upCallback) {
            selected.config.upCallback();
        }
        else {
            this.config.menuNavigator.onUp(this);
        }
    }
    leftPressed() {
        if (this.inputForbidden)
            return;
        const selected = this.getSelectedOption();
        if (selected && selected.config.leftCallback) {
            selected.config.leftCallback();
        }
        else {
            this.config.menuNavigator.onLeft(this);
        }
    }
    rightPressed() {
        if (this.inputForbidden)
            return;
        const selected = this.getSelectedOption();
        if (selected && selected.config.rightCallback) {
            selected.config.rightCallback();
        }
        else {
            this.config.menuNavigator.onRight(this);
        }
    }
    cancelPressed() {
        if (this.inputForbidden)
            return;
        const selected = this.getSelectedOption();
        if (selected && selected.config.cancelCallback) {
            selected.config.cancelCallback();
        }
        else if (this.config.cancelCallback) {
            this.config.cancelCallback();
        }
    }
    confirmPressed() {
        if (this.inputForbidden)
            return;
        const selected = this.getSelectedOption();
        if (selected && selected.config.confirmCallback) {
            selected.config.confirmCallback();
        }
        else if (this.config.confirmCallback) {
            this.config.confirmCallback();
        }
    }
    setPreviousIndex(userInitiated = true) {
        for (let i = 1; i <= this.options.length; i++) {
            const adj_idx = (0, KHHelperFunctions_1.inRange)(this.selectedIndex - i, this.options.length);
            if (this.options[adj_idx].getIsSelectable()) {
                this.setSelectedIndex(adj_idx, userInitiated);
                return;
            }
        }
    }
    setNextIndex(userInitiated = true) {
        for (let i = 1; i <= this.options.length; i++) {
            const adj_idx = (0, KHHelperFunctions_1.inRange)(this.selectedIndex + i, this.options.length);
            if (this.options[adj_idx].getIsSelectable()) {
                this.setSelectedIndex(adj_idx, userInitiated);
                return;
            }
        }
    }
    setSelectedIndex(index, userInitiated = true) {
        if (index < 0 || index >= this.options.length) {
            index = -1;
        }
        let lastIndex = this.selectedIndex;
        let last = this.options[this.selectedIndex];
        last === null || last === void 0 ? void 0 : last.setIsSelected(false);
        this.selectedIndex = index;
        let current = this.options[this.selectedIndex];
        current === null || current === void 0 ? void 0 : current.setIsSelected(true);
        this.emitEvent("update_selection", { index: this.selectedIndex, lastIndex: lastIndex, option: current, lastOption: last, userInitiated: userInitiated });
        this.sendUpdateDescriptionEvent(current);
    }
    sendUpdateDescriptionEvent(current) {
        var _a;
        if (current instanceof KHMenuEntryV3_1.KHMenuEntryV3) {
            this.emitEvent("description_updated", { description: (_a = current === null || current === void 0 ? void 0 : current.getDescription()) !== null && _a !== void 0 ? _a : "" });
        }
        else {
            this.emitEvent('description_updated', { description: current });
        }
    }
    /**
     * Returns a list of menu options. Changes to this list will not be
     * reflected in the menu spec.
     */
    getOptions() {
        return [...this.options];
    }
    /**
     * Gets access to the raw options array. Presented for efficiency, do not
     * alter this list because who knows what might happen.
     */
    getOptionsRaw() {
        return this.options;
    }
}
exports.KHMenuSpecV3 = KHMenuSpecV3;
